import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/solutions/operational-excellence")({
  head: () => buildRouteHead("/es/solutions/operational-excellence", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/soluciones/operational-excellence", replace: true });
  },
});
